import * as React from "react";
const SvgFiRrChessKnightAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chess-knight-alt_svg__a)">
      <path
        fill="#062147"
        d="M20 18.173V8.5c0-.08-.1-7.963-8.536-8.5A1.98 1.98 0 0 0 9.41 1.386a5.29 5.29 0 0 1-3.5 3.846A3.02 3.02 0 0 0 4 8.026 1.977 1.977 0 0 0 5.975 10h4.247a5.68 5.68 0 0 1-3.181 3.416A5.08 5.08 0 0 0 4 18v.17A3 3 0 0 0 5 24h14a3 3 0 0 0 1-5.828M7.86 15.24a7.77 7.77 0 0 0 4.626-6.076A1 1 0 0 0 11.5 8L6 8.026a1.025 1.025 0 0 1 .663-.94A7.33 7.33 0 0 0 11.339 2a6.607 6.607 0 0 1 6.66 6.5V18H6a3.04 3.04 0 0 1 1.862-2.76M19 22H5a1 1 0 1 1 0-2h14a1 1 0 0 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chess-knight-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChessKnightAlt;
